import type { AutocompleteProps } from '@mantine/core';
import { Autocomplete } from '@mantine/core';
import { IconChevronDown } from 'ui-icons';

import classes from './Autocomplete.module.css';

const AutocompleteInputDefaultProps = {
  radius: 'sm',
  rightSection: <IconChevronDown size="12px" />,
};

const AutocompleteInputDefaults = Autocomplete.extend({
  defaultProps: AutocompleteInputDefaultProps,
  classNames: {
    dropdown: classes.dropdown,
    options: classes.options,
    option: classes.option,
    group: classes.group,
    groupLabel: classes.group_label,
  },
});

export { Autocomplete, AutocompleteInputDefaults };
export type { AutocompleteProps };
